import script from "./PackagesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackagesList.vue?vue&type=script&setup=true&lang=ts"

import "./PackagesList.vue?vue&type=style&index=0&id=6ff0c5ef&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff0c5ef"]])

export default __exports__